import { Component, Inject, Prop, PropSync, Vue } from 'vue-property-decorator'
import VtFlags from '@/components/common/VtFlags.vue'
import { TranslationResponse } from '@/api/services/common.dto'
import { CommonLanguageResponse } from '@/api/services/common/language/common-language.dto'
import { Validator } from 'vee-validate'
import { ConfigurationFieldsTranslationsState, initialConfigurationFieldsTranslationsState } from '@/modules/configurationModule/shared/components/configuration-fields-translations/configuration-fields-translations.model'
import languageService from '@/api/resources/common/languageService'
import { cloneDeep, orderBy, uniqBy } from 'lodash'

@Component({
    components: {
        VtFlags
    }
})
export default class ConfigurationFieldsTranslations extends Vue {
    @PropSync('nameTranslations') syncedNameTranslations!: TranslationResponse[]
    @Prop(String) fieldName!: string

    @Inject() externalValidator!: Validator

    state: ConfigurationFieldsTranslationsState

    get translations(): Partial<TranslationResponse>[] {
        const translations: Partial<TranslationResponse>[] = [ ...cloneDeep(this.syncedNameTranslations), ...cloneDeep(this.state.availableLanguages) ]
        return ConfigurationFieldsTranslations._orderByTranslations(translations)
    }

    constructor() {
        super()
        this.$validator = this.externalValidator
        this.state = initialConfigurationFieldsTranslationsState()
    }

    async created() {
        this.state.availableLanguages = await this._loadAvailableLanguages()
    }

    private async _getTranslations(): Promise<CommonLanguageResponse[]> {
        const [err, response] = await this.$_toCall(languageService.findAllActiveAndUiEnabled())
        if (err) {
            this.$_showErrorModalFromErrorResponse(err)
            return []
        }
        return response
    }

    private async _loadAvailableLanguages(): Promise<Partial<TranslationResponse>[]> {
        const translations = await this._getTranslations()
        return translations
            .filter(translation => translation.active)
            .map((language: CommonLanguageResponse) => ({
                language
            }))
    }

    private static _orderByTranslations(translations: Partial<TranslationResponse>[], typeOrder: string[] = ['language.id']): Partial<TranslationResponse>[] {
        return orderBy(uniqBy(translations, typeOrder?.[0]), typeOrder)
    }

    updateField(): void {
        this.syncedNameTranslations = this.translations as TranslationResponse[] // emits an 'update:nameTranslations' event (for the synced prop)
    }
}
